module.exports = __webpack_public_path__ + "img/home_about.8e3c5e64.jpg";